import { useEffect } from 'react';
import Explainer from '../blocks';
import gsap from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

import styles from './GetControl.module.css';

const EXPLAINER_WIDTH = 662;
const EXPLAINER_HEIGHT = 460;

gsap.registerPlugin(MotionPathPlugin);

const GetControl = () => {
  useEffect(() => {
    const circles = Array.from(document.getElementsByClassName(styles.circle));
    const paths = Array.from(document.getElementsByClassName(styles.path));

    const tl = gsap.timeline({ repeat: -1 });

    circles.forEach((circle, index) => {
      const path = paths[index];

      tl.to(circle, {
        duration: 1,
        ease: 'none',
        motionPath: {
          path: path,
          align: path,
          alignOrigin: [0.5, 0.5],
          autoRotate: false,
        },
      });

      tl.to(
        {},
        {
          duration: 1,
        },
      );
    });
  }, []);

  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
    >
      <g transform="translate(93, 8)">
        <path
          className={styles.path}
          d="M32 81.6055 L160 81.6055"
          stroke="#57C7A4"
          strokeDasharray="2 2"
        />
        <path
          className={styles.path}
          d="M32 152.605 L160 152.605"
          stroke="#57C7A4"
          strokeDasharray="2 2"
        />
        <path
          className={styles.path}
          d="M32 221.605 L160 221.605"
          stroke="#57C7A4"
          strokeDasharray="2 2"
        />
        <path
          className={styles.path}
          d="M32 290.605 L160 290.605"
          stroke="#57C7A4"
          strokeDasharray="2 2"
        />
        <path
          className={styles.path}
          d="M32 359.605 L160 359.605"
          stroke="#57C7A4"
          strokeDasharray="2 2"
        />
        <g transform="translate(40, 74)">
          <circle
            className={styles.circle}
            cx="7.5"
            cy="78.5"
            r="7.5"
            fill="var(--brand-color-white)"
          />
          <circle
            className={styles.circle}
            cx="7.5"
            cy="7.5"
            r="7.5"
            fill="var(--brand-color-white)"
          />
          <circle
            className={styles.circle}
            cx="7.5"
            cy="147.5"
            r="7.5"
            fill="var(--brand-color-white)"
          />
          <circle
            className={styles.circle}
            cx="7.5"
            cy="216.5"
            r="7.5"
            fill="var(--brand-color-white)"
          />
          <circle
            className={styles.circle}
            cx="7.5"
            cy="285.5"
            r="7.5"
            fill="var(--brand-color-white)"
          />
        </g>
        <rect y="57.1074" width="55" height="53" rx="6" fill="white" />
        <g clipPath="url(#clip0_2375_90772_0)">
          <path
            d="M29.5623 72.7724L30.3873 72.9558L31.0565 73.1941L31.5973 73.4691L32.0098 73.7624L32.3215 74.0741L32.5507 74.3858L32.6973 74.6883L32.789 74.9633L32.8257 75.2016L32.844 75.3849L32.8348 75.5041V80.3991L32.789 80.9766L32.6698 81.4808L32.4773 81.9024L32.239 82.2508L31.964 82.5349L31.6615 82.7641L31.3407 82.9383L31.0198 83.0666L30.7173 83.1583L30.4423 83.2224L30.204 83.2591L30.0115 83.2774H24.539L23.9065 83.3233L23.3657 83.4516L22.9073 83.6533L22.5315 83.9008L22.229 84.1941L21.9815 84.5149L21.7982 84.8449L21.6607 85.1841L21.569 85.5049L21.5048 85.7983L21.4682 86.0458L21.4498 86.2383V89.0433H19.4057L19.2132 89.0158L18.9565 88.9516L18.6632 88.8416L18.3423 88.6766L18.0123 88.4383L17.6823 88.1083L17.3615 87.6866L17.0682 87.1458L16.8115 86.4766L16.619 85.6699L16.4907 84.7074L16.4448 83.5799L16.4998 82.4616L16.6465 81.5083L16.8665 80.7108L17.1598 80.0599L17.4898 79.5374L17.8565 79.1341L18.2415 78.8316L18.6265 78.6116L18.9932 78.4649L19.3232 78.3733L19.6165 78.3274L19.8365 78.3183H19.9832L20.0382 78.3274H27.5182V77.5666H22.1648L22.1557 75.0458L22.1373 74.7066L22.1832 74.3949L22.284 74.1108L22.4398 73.8541L22.669 73.6158L22.9532 73.4049L23.3015 73.2216L23.7048 73.0566L24.1723 72.9191L24.704 72.8091L25.2907 72.7174L25.9415 72.6624L26.6473 72.6258L27.4173 72.6074L28.5815 72.6533L29.5623 72.7724ZM23.7873 74.5874L23.5765 74.8899L23.5032 75.2658L23.5765 75.6416L23.7873 75.9533L24.0898 76.1549L24.4657 76.2374L24.8415 76.1549L25.144 75.9533L25.3548 75.6416L25.4282 75.2658L25.3548 74.8899L25.144 74.5874L24.8415 74.3858L24.4657 74.3033L24.0898 74.3858L23.7873 74.5874ZM35.7865 78.2083L36.0432 78.2633L36.3365 78.3733L36.6573 78.5383L36.9873 78.7858L37.3173 79.1066L37.6382 79.5374L37.9315 80.0783L38.1882 80.7474L38.3807 81.5541L38.509 82.5074L38.5548 83.6349L38.4998 84.7624L38.3532 85.7158L38.1332 86.5041L37.8398 87.1549L37.5098 87.6774L37.1432 88.0899L36.7582 88.3924L36.3732 88.6124L36.0065 88.7591L35.6765 88.8416L35.3832 88.8874L35.1632 88.9058L35.0165 88.8966H27.4815V89.6483H32.8348L32.844 92.1783L32.8623 92.5083L32.8165 92.8199L32.7157 93.1041L32.5598 93.3699L32.3307 93.5991L32.0465 93.8191L31.6982 94.0024L31.2948 94.1583L30.8273 94.2958L30.2957 94.4149L29.709 94.4974L29.0582 94.5616L28.3523 94.5983L27.5823 94.6074L26.4182 94.5708L25.4373 94.4424L24.6123 94.2591L23.9432 94.0299L23.4023 93.7549L22.9898 93.4524L22.6782 93.1408L22.449 92.8291L22.3023 92.5266L22.2107 92.2516L22.174 92.0224L22.1557 91.8391L22.1648 91.7199V86.8249L22.2107 86.2383L22.3298 85.7433L22.5223 85.3216L22.7607 84.9733L23.0357 84.6799L23.3382 84.4599L23.659 84.2766L23.9798 84.1483L24.2823 84.0566L24.5573 84.0016L24.7957 83.9649L24.9882 83.9466L25.1073 83.9374H30.4607L31.0932 83.8916L31.634 83.7633L32.0923 83.5708L32.4682 83.3141L32.7707 83.0208L33.0182 82.6999L33.2015 82.3699L33.339 82.0399L33.4307 81.7191L33.4948 81.4258L33.5315 81.1691L33.5498 80.9766V78.1716H35.4657L35.594 78.1808L35.7865 78.2083ZM29.8557 91.2708L29.6448 91.5733L29.5715 91.9491L29.6448 92.3249L29.8557 92.6274L30.1582 92.8383L30.534 92.9116L30.9098 92.8383L31.2123 92.6274L31.4232 92.3249L31.4965 91.9491L31.4232 91.5733L31.2123 91.2708L30.9098 91.0599L30.534 90.9866L30.1582 91.0599L29.8557 91.2708Z"
            fill="#768FA2"
          />
        </g>
        <rect y="126.107" width="55" height="53" rx="6" fill="white" />
        <g clipPath="url(#clip1_2375_90772_1)">
          <path
            d="M40.4958 157.297C40.378 156.081 36.8263 155.685 34.3024 154.588C34.8545 153.486 35.6919 152.239 35.3303 149.944C34.8468 146.893 32.2202 141.494 27.4999 141.494C22.7798 141.494 20.1531 146.889 19.6696 149.944C19.308 152.239 20.1493 153.486 20.6975 154.588C18.1774 155.685 14.6258 156.085 14.5041 157.297C14.3936 158.422 16.552 158.832 18.9844 158.686C18.3716 159.435 17.892 160.145 17.93 160.655C17.9909 161.511 18.9007 162.067 20.3358 162.067C21.9422 162.067 24.4243 161.05 25.0142 158.303C25.0142 158.303 24.7705 159.404 24.9037 160.459C25.0636 161.718 26.0077 163.721 27.4999 163.721C28.9921 163.721 29.9363 161.718 30.096 160.459C30.2293 159.404 29.9858 158.303 29.9858 158.303C30.5757 161.05 33.0539 162.067 34.6641 162.067C36.0992 162.067 37.009 161.511 37.0699 160.655C37.108 160.145 36.6246 159.431 36.0155 158.686C38.4479 158.832 40.6062 158.422 40.4958 157.297ZM22.5551 146.057C22.2734 145.815 22.3496 145.293 22.7227 144.89C23.0957 144.487 23.6285 144.353 23.9102 144.594C24.1919 144.836 24.1158 145.358 23.7428 145.761C23.3697 146.164 22.8368 146.295 22.5551 146.057ZM25.1246 153.011C23.9636 153.011 23.0233 152.063 23.0233 150.892C23.0233 149.722 23.9636 148.774 25.1246 148.774C26.2856 148.774 27.2259 149.722 27.2259 150.892C27.2259 152.059 26.2855 153.011 25.1246 153.011ZM26.4074 144.667C25.5889 145.036 24.7173 144.909 24.4585 144.387C24.1996 143.861 24.6526 143.14 25.471 142.772C26.2894 142.403 27.1612 142.53 27.42 143.052C27.6789 143.574 27.2259 144.299 26.4074 144.667ZM32.0602 153.01C30.8993 153.01 29.959 152.063 29.959 150.892C29.959 149.722 30.8993 148.774 32.0603 148.774C33.2214 148.774 34.1617 149.722 34.1617 150.892C34.1617 152.059 33.2212 153.01 32.0602 153.01ZM32.2316 150.877L33.0044 149.96C32.8824 149.832 32.7359 149.731 32.5736 149.661C32.4114 149.592 32.2368 149.556 32.0603 149.557C31.3295 149.557 30.7394 150.151 30.7394 150.888C30.7394 151.625 31.3295 152.22 32.0603 152.22C32.7913 152.22 33.3813 151.625 33.3813 150.888V150.877H32.2316ZM26.4417 150.877V150.888C26.4417 151.625 25.8517 152.22 25.1207 152.22C24.3899 152.22 23.7999 151.625 23.7999 150.888C23.7999 150.152 24.3899 149.557 25.1207 149.557C25.49 149.557 25.8249 149.71 26.0649 149.96L25.2921 150.877L26.4417 150.877Z"
            fill="#768FA2"
          />
        </g>
        <rect y="195.107" width="55" height="53" rx="6" fill="white" />
        <path
          d="M30.1559 220.823H31.9581C31.9999 220.823 32.04 220.807 32.0697 220.777C32.0993 220.748 32.1161 220.708 32.1163 220.666V219.061C32.1163 219.019 32.0996 218.979 32.0699 218.949C32.0404 218.919 32.0001 218.903 31.9581 218.903H30.1559C30.1142 218.903 30.0741 218.919 30.0446 218.949C30.0151 218.978 29.9985 219.018 29.9985 219.06V220.666C29.9985 220.753 30.0691 220.823 30.1559 220.823ZM27.6434 216.205H29.4449C29.4868 216.205 29.527 216.188 29.5567 216.159C29.5864 216.129 29.6031 216.089 29.6031 216.047V214.441C29.6029 214.399 29.5861 214.359 29.5564 214.33C29.5268 214.3 29.4866 214.284 29.4449 214.284H27.6434C27.6017 214.284 27.5617 214.3 27.5322 214.33C27.5027 214.359 27.4861 214.399 27.4861 214.441V216.047C27.4861 216.134 27.5559 216.205 27.6434 216.205ZM27.6434 218.514H29.4449C29.4867 218.514 29.5268 218.497 29.5565 218.468C29.5861 218.438 29.6029 218.398 29.6031 218.356V216.751C29.6029 216.709 29.5861 216.669 29.5564 216.64C29.5268 216.61 29.4866 216.594 29.4449 216.594H27.6434C27.6017 216.594 27.5617 216.61 27.5322 216.64C27.5027 216.669 27.4861 216.709 27.4861 216.751V218.356C27.4861 218.443 27.5559 218.513 27.6434 218.514ZM25.1515 218.514H26.9545C26.9962 218.514 27.036 218.497 27.0654 218.467C27.0946 218.438 27.1111 218.398 27.1111 218.356V216.751C27.1111 216.709 27.0945 216.669 27.0649 216.64C27.0355 216.61 26.9955 216.594 26.9537 216.594H25.1523C25.1106 216.594 25.0706 216.61 25.0411 216.64C25.0116 216.669 24.995 216.709 24.995 216.751V218.356C24.995 218.443 25.0647 218.513 25.1515 218.514ZM22.6314 218.514H24.4337C24.4755 218.514 24.5155 218.497 24.545 218.467C24.5744 218.438 24.591 218.398 24.591 218.356V216.751C24.591 216.709 24.5744 216.669 24.5449 216.64C24.5154 216.61 24.4754 216.594 24.4337 216.594H22.6314C22.5896 216.594 22.5495 216.61 22.5199 216.64C22.4902 216.669 22.4734 216.709 22.4732 216.751V218.356C22.4732 218.443 22.5447 218.513 22.6314 218.514ZM27.6434 220.823H29.4449C29.4866 220.823 29.5268 220.807 29.5564 220.777C29.5861 220.748 29.6029 220.708 29.6031 220.666V219.061C29.6031 219.019 29.5864 218.979 29.5567 218.949C29.527 218.919 29.4868 218.903 29.4449 218.903H27.6434C27.6017 218.903 27.5617 218.919 27.5322 218.949C27.5027 218.978 27.4861 219.018 27.4861 219.06V220.666C27.4861 220.753 27.5559 220.823 27.6434 220.823ZM25.1515 220.823H26.9545C26.9961 220.823 27.0359 220.806 27.0653 220.777C27.0946 220.747 27.1111 220.708 27.1111 220.666V219.061C27.1112 219.04 27.1072 219.02 27.0994 219.001C27.0916 218.982 27.0801 218.964 27.0656 218.949C27.0511 218.935 27.0337 218.923 27.0147 218.915C26.9957 218.907 26.9752 218.903 26.9545 218.903H25.1515C25.1099 218.903 25.0701 218.92 25.0408 218.949C25.0114 218.979 24.995 219.019 24.995 219.06V220.666C24.995 220.753 25.0647 220.823 25.1515 220.823ZM22.6314 220.823H24.4337C24.4754 220.823 24.5154 220.807 24.5449 220.777C24.5744 220.748 24.591 220.708 24.591 220.666V219.061C24.5911 219.04 24.5871 219.02 24.5793 219.001C24.5715 218.982 24.56 218.964 24.5455 218.949C24.531 218.935 24.5137 218.923 24.4946 218.915C24.4756 218.907 24.4552 218.903 24.4345 218.903H22.6314C22.5895 218.903 22.5492 218.919 22.5196 218.949C22.4899 218.979 22.4732 219.019 22.4732 219.061V220.666C22.4732 220.753 22.5447 220.823 22.6314 220.823ZM20.1479 220.823H21.951C21.9926 220.823 22.0324 220.806 22.0617 220.777C22.091 220.747 22.1075 220.708 22.1075 220.666V219.061C22.1076 219.04 22.1037 219.02 22.0959 219.001C22.0881 218.982 22.0766 218.964 22.062 218.949C22.0475 218.935 22.0302 218.923 22.0112 218.915C21.9921 218.907 21.9717 218.903 21.951 218.903H20.1479C20.1064 218.903 20.0665 218.92 20.0372 218.949C20.0079 218.979 19.9914 219.019 19.9914 219.06V220.666C19.9914 220.753 20.0603 220.823 20.1479 220.823ZM38.4738 219.813C38.4186 219.769 37.9023 219.379 36.812 219.379C36.5245 219.38 36.237 219.405 35.9529 219.453C35.742 218.007 34.5471 217.301 34.4935 217.271L34.201 217.101L34.0087 217.38C33.7672 217.752 33.5919 218.164 33.4881 218.596C33.2926 219.421 33.4116 220.196 33.8309 220.859C33.3249 221.141 32.5127 221.21 32.3476 221.216H18.9019C18.7331 221.216 18.5713 221.283 18.4517 221.403C18.3322 221.522 18.2647 221.684 18.264 221.852C18.2483 223.03 18.4478 224.201 18.8526 225.307C19.3161 226.522 20.005 227.416 20.9023 227.964C21.9059 228.579 23.5389 228.931 25.3888 228.931C26.2248 228.934 27.0583 228.858 27.8808 228.705C29.0228 228.495 30.1219 228.096 31.1323 227.524C31.9657 227.041 32.7142 226.428 33.3521 225.707C34.417 224.501 35.0514 223.158 35.5235 221.965H35.7114C36.8783 221.965 37.5953 221.498 37.9908 221.107C38.2536 220.857 38.4586 220.554 38.592 220.217L38.6754 219.972L38.4738 219.813Z"
          fill="#768FA2"
        />
        <rect y="264.107" width="55" height="53" rx="6" fill="white" />
        <path
          d="M19.7083 278.609C19.3963 278.596 19.0433 278.681 18.8803 279.066C18.7223 279.44 18.5973 280.254 18.5403 281.342L19.7633 281.933C19.7433 281.196 19.7703 280.503 19.8393 279.867C19.8133 280.166 19.7833 280.827 19.8453 281.906C19.8643 282.248 19.8943 282.631 19.9333 283.056C19.9353 283.08 19.9353 283.103 19.9403 283.125C20.0218 283.931 20.1248 284.736 20.2493 285.537C20.3063 285.905 20.3753 286.289 20.4443 286.697L20.4343 286.707C20.4483 286.717 20.4493 286.725 20.4483 286.73L20.4783 286.89C20.5083 287.052 20.5383 287.218 20.5713 287.384L20.6793 287.937L20.7353 288.226C20.8758 288.917 21.0281 289.607 21.1923 290.294C21.2823 290.676 21.3783 291.074 21.4793 291.48C21.5773 291.866 21.6783 292.263 21.7883 292.673C21.8843 293.035 21.9873 293.408 22.0913 293.79C22.0943 293.808 22.1033 293.826 22.1063 293.845C22.2179 294.24 22.3313 294.635 22.4463 295.03L22.4953 295.204C22.5733 295.465 22.6533 295.737 22.7373 296.009C22.6379 295.967 22.5402 295.922 22.4443 295.874L22.2543 295.22C22.2343 295.143 22.2123 295.072 22.1923 294.995L22.1903 294.991L22.1863 294.989C22.0993 294.689 22.0163 294.382 21.9293 294.073C21.9063 293.986 21.8853 293.9 21.8603 293.81L21.5463 292.632C21.4463 292.251 21.3523 291.867 21.2563 291.478C21.1623 291.088 21.0713 290.698 20.9793 290.306C20.8863 289.905 20.7983 289.506 20.7143 289.103C20.6293 288.707 20.5533 288.305 20.4743 287.91C20.3993 287.52 20.329 287.13 20.2633 286.74C20.2593 286.727 20.2573 286.71 20.2533 286.699L20.2573 286.697C20.2003 286.311 20.1413 285.927 20.0833 285.547C20.028 285.146 19.9766 284.744 19.9293 284.343C19.8366 283.542 19.7792 282.738 19.7573 281.933L18.5373 281.343C18.5333 281.417 18.5273 281.493 18.5243 281.573C18.5123 281.867 18.5043 282.178 18.5013 282.503C18.4984 282.888 18.5004 283.274 18.5073 283.66C18.5163 284.03 18.5323 284.415 18.5523 284.808C18.5723 285.144 18.5943 285.483 18.6223 285.83L18.6243 285.869L18.6303 285.873C18.6333 285.896 18.6373 285.923 18.6363 285.949C18.6693 286.317 18.7003 286.688 18.7433 287.064C18.8222 287.775 18.9233 288.484 19.0463 289.189C19.0563 289.253 19.0703 289.32 19.0813 289.384C19.2241 290.166 19.4067 290.94 19.6283 291.704C19.6983 291.941 19.7683 292.168 19.8383 292.384C19.9013 292.566 19.9683 292.749 20.0323 292.929C20.1873 293.351 20.3593 293.761 20.5443 294.161L20.5503 294.165C20.5555 294.182 20.5622 294.198 20.5703 294.215C20.7953 294.7 21.0453 295.165 21.3253 295.61C21.3353 295.623 21.3453 295.643 21.3553 295.657C20.9003 295.474 20.0963 295.559 20.1023 295.56C20.9323 295.848 21.6593 296.2 22.1183 296.735C21.9353 296.935 21.5953 297.087 21.1653 297.212C21.7593 297.276 22.0893 297.173 22.2103 297.12C21.9003 297.38 21.7273 297.851 21.5753 298.359C21.9253 297.789 22.2713 297.411 22.6083 297.266C22.6863 297.524 22.7703 297.789 22.8523 298.053C22.0849 299.559 21.3435 301.077 20.6283 302.607C20.7202 302.595 20.8076 302.56 20.8826 302.506C20.9577 302.451 21.018 302.379 21.0583 302.295C21.1883 302.013 21.8883 300.52 22.9663 298.42C23.3792 299.723 23.8462 301.099 24.3522 302.529C24.4026 302.464 24.436 302.388 24.4493 302.307C24.4625 302.225 24.4553 302.142 24.4282 302.064C23.9659 300.758 23.5299 299.443 23.1203 298.119C23.2743 297.82 23.4362 297.508 23.6042 297.188C23.7292 297.228 23.8592 297.282 23.9932 297.343C24.1962 297.529 24.3452 297.833 24.4752 298.182C24.5122 297.787 24.3923 297.393 24.1412 297.085C25.4762 297.343 26.6882 297.175 27.4282 296.275C27.4957 296.191 27.5597 296.105 27.6202 296.017C27.2952 296.321 26.9382 296.421 26.3072 296.29C27.3032 296.009 27.8302 295.673 28.3422 295.07C28.4622 294.925 28.5862 294.767 28.7132 294.59C27.7702 295.312 26.7862 295.412 25.8132 295.083L25.7682 295.065C26.6822 295.085 27.9712 294.591 28.8602 293.876C29.2702 293.546 29.6562 293.146 30.0302 292.666C30.3102 292.307 30.5802 291.906 30.8502 291.45C31.0842 291.057 31.3182 290.626 31.5502 290.157C31.3107 290.235 31.0618 290.281 30.8102 290.294L30.6662 290.302C30.6182 290.304 30.5732 290.302 30.5202 290.304C31.4052 290.106 32.0202 289.564 32.5142 288.857C32.2742 288.974 31.8862 289.119 31.4442 289.154C31.3862 289.16 31.3242 289.16 31.2622 289.16C31.2492 289.158 31.2342 289.16 31.2152 289.158C31.5212 289.08 31.7892 288.98 32.0252 288.849C32.1494 288.778 32.269 288.699 32.3832 288.613C32.4272 288.576 32.4712 288.543 32.5132 288.507C32.6122 288.421 32.7062 288.327 32.7932 288.22C32.8212 288.186 32.8492 288.157 32.8732 288.122C32.9092 288.072 32.9462 288.024 32.9772 287.976C33.163 287.71 33.3333 287.433 33.4872 287.148C33.5022 287.117 33.5192 287.091 33.5332 287.06C33.5732 286.976 33.6132 286.9 33.6432 286.833C33.6852 286.734 33.7172 286.654 33.7352 286.595C33.7013 286.616 33.665 286.633 33.6272 286.646C33.3542 286.758 32.9002 286.833 32.5412 286.847C32.5372 286.847 32.5332 286.847 32.5282 286.851H32.4612C33.1812 286.637 33.5282 286.401 33.8831 286.033C34.2989 285.583 34.6844 285.106 35.0371 284.605C35.3011 284.235 35.5421 283.867 35.7291 283.533C35.8385 283.34 35.9379 283.143 36.0271 282.941C36.0931 282.784 36.1491 282.636 36.1991 282.491C35.7331 282.501 35.2131 282.502 34.7191 282.491C35.2141 282.501 35.7341 282.498 36.2031 282.486C36.7031 281.001 36.2661 280.224 36.2661 280.224C36.2661 280.224 35.7401 279.012 34.8661 279.373C34.4401 279.548 33.6942 280.103 32.7832 280.933L33.2972 282.383C33.8286 281.811 34.3975 281.276 35.0001 280.781C34.7431 281.001 34.1931 281.507 33.3852 282.425C33.1292 282.715 32.8482 283.049 32.5412 283.422C32.5242 283.442 32.5062 283.46 32.4942 283.482C31.9194 284.196 31.3639 284.925 30.8282 285.669C30.5802 286.009 30.3302 286.373 30.0632 286.757H30.0472C30.0492 286.777 30.0432 286.785 30.0372 286.789L29.9362 286.941C29.8322 287.096 29.7232 287.251 29.6182 287.411L29.2662 287.945C29.2052 288.035 29.1422 288.126 29.0802 288.222C28.8962 288.504 28.7132 288.795 28.5222 289.095C28.0353 289.867 27.5592 290.647 27.0942 291.433C26.6364 292.207 26.1893 292.988 25.7532 293.776C25.7412 293.793 25.7332 293.816 25.7192 293.833C25.4951 294.239 25.2725 294.647 25.0512 295.056L24.9542 295.237C24.7842 295.555 24.6082 295.879 24.4342 296.216C24.4342 296.22 24.4292 296.224 24.4282 296.229C24.4022 296.277 24.3782 296.322 24.3562 296.37C24.2393 296.592 24.1382 296.794 23.9062 297.24C23.8355 297.171 23.7573 297.109 23.6733 297.058L24.0183 296.408C24.0653 296.319 24.1143 296.231 24.1613 296.138L24.2013 296.061L24.7472 295.06L24.8772 294.827V294.821L24.8762 294.815C25.0452 294.505 25.2212 294.195 25.3962 293.875C25.4472 293.788 25.4982 293.702 25.5492 293.61C25.7732 293.215 26.0032 292.816 26.2332 292.413C26.9187 291.229 27.6305 290.061 28.3682 288.909C28.6152 288.523 28.8712 288.139 29.1222 287.757C29.2142 287.619 29.3042 287.485 29.4012 287.347C29.5598 287.112 29.7198 286.878 29.8812 286.646C29.8882 286.634 29.9002 286.622 29.9072 286.609H29.9132C30.1732 286.253 30.4302 285.896 30.6862 285.544C30.9642 285.171 31.2402 284.809 31.5162 284.454C32.0778 283.736 32.6707 283.044 33.2932 282.379L32.7782 280.933C32.7182 280.99 32.6522 281.049 32.5862 281.111C32.3296 281.35 32.0769 281.593 31.8282 281.84C31.5332 282.134 31.2312 282.446 30.9162 282.775C30.3559 283.373 29.8117 283.986 29.2842 284.613L29.2542 284.646L29.2562 284.654C29.2392 284.674 29.2232 284.698 29.2022 284.718C28.9362 285.041 28.6642 285.367 28.4012 285.703C27.8995 286.337 27.4176 286.988 26.9562 287.653C26.9132 287.713 26.8712 287.779 26.8292 287.839C26.3227 288.582 25.8544 289.351 25.4262 290.142C25.2962 290.389 25.1702 290.627 25.0562 290.857C24.9602 291.052 24.8692 291.252 24.7782 291.448C24.5682 291.911 24.3802 292.378 24.2122 292.847L24.2142 292.853C24.2039 292.871 24.1952 292.89 24.1882 292.911C24.0802 293.214 23.9852 293.519 23.8982 293.825C23.7582 293.999 23.5962 294.15 23.4152 294.285C23.3731 294.232 23.3294 294.181 23.2843 294.132C23.7264 293.468 24.0085 292.711 24.1082 291.921C24.1608 291.426 24.1554 290.926 24.0922 290.433C24.0462 290.033 23.9662 289.613 23.8542 289.159C23.7572 288.766 23.6373 288.349 23.4913 287.911C23.4003 288.096 23.2712 288.278 23.1123 288.456L23.0263 288.55C22.9973 288.582 22.9663 288.61 22.9343 288.644C23.3683 287.97 23.4203 287.247 23.2923 286.496C23.1818 286.806 23.0157 287.094 22.8023 287.346C22.7693 287.384 22.7303 287.423 22.6923 287.462C22.6823 287.469 22.6733 287.48 22.6593 287.49C22.8033 287.25 22.9093 287.023 22.9773 286.792C22.9934 286.744 23.0068 286.695 23.0173 286.646C23.0329 286.571 23.0456 286.496 23.0553 286.421L23.0733 286.275C23.0825 286.157 23.0818 286.038 23.0713 285.921C23.0683 285.881 23.0673 285.845 23.0613 285.808C23.0513 285.753 23.0453 285.703 23.0343 285.654C22.9863 285.37 22.9218 285.09 22.8413 284.814C22.8313 284.786 22.8263 284.758 22.8153 284.73C22.7883 284.651 22.7673 284.581 22.7433 284.521C22.7171 284.449 22.687 284.38 22.6533 284.312C22.6455 284.346 22.6338 284.38 22.6183 284.412C22.5163 284.652 22.2783 284.982 22.0613 285.212C22.0583 285.215 22.0543 285.217 22.0543 285.222L22.0143 285.265C22.3323 284.685 22.4043 284.319 22.3993 283.867C22.3816 283.325 22.3282 282.786 22.2393 282.252C22.1814 281.88 22.104 281.511 22.0073 281.148C21.9566 280.959 21.8966 280.773 21.8273 280.59C21.7744 280.457 21.717 280.327 21.6553 280.199L21.6573 280.195C21.0473 278.949 20.2913 278.732 20.2913 278.732C20.2913 278.732 20.0203 278.622 19.7083 278.609ZM23.0883 294.392L23.1203 294.474V294.476C23.0603 294.509 23.0043 294.543 22.9423 294.573C22.9303 294.577 22.9183 294.585 22.9033 294.591C22.969 294.527 23.0311 294.461 23.0893 294.391L23.0883 294.392ZM22.4853 296.018C22.6153 296.154 22.7353 296.26 22.8393 296.338L22.9093 296.565C22.8262 296.577 22.744 296.594 22.6633 296.618L22.6333 296.52C22.6093 296.436 22.5853 296.35 22.5573 296.263L22.5363 296.19L22.4853 296.018ZM22.7453 296.893C22.8357 296.891 22.9262 296.894 23.0163 296.903L23.0863 297.132C23.1678 297.117 23.2512 297.116 23.3333 297.128L23.0073 297.754C22.9189 297.467 22.8316 297.18 22.7453 296.893Z"
          fill="#768FA2"
        />
        <rect y="333.107" width="55" height="53" rx="6" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.1668 350.941H18.8335V368.274H36.1668V350.941ZM32.7002 353.974H22.3002V365.241H27.5002V356.574H30.1002V365.241H32.7002V353.974Z"
          fill="#768FA2"
        />
        <g filter="url(#filter5_d_2375_90772)">
          <g clipPath="url(#clip2_2375_90772_2)">
            <path
              d="M134 32.9195C134 29.0979 137.098 26 140.919 26H569V445.081C569 448.902 565.902 452 562.081 452H134V32.9195Z"
              fill="white"
            />
            <rect
              x="144"
              y="36"
              width={`${EXPLAINER_WIDTH}`}
              height="426"
              fill="url(#dot-pattern)"
              stroke="none"
            />
            <rect
              x="203.484"
              y="176.906"
              width="300.032"
              height="63.8778"
              rx="7.25884"
              fill="#FAFCFD"
              stroke="#E6EAEC"
              strokeWidth="0.967846"
            />
            <text
              x="226"
              y="203"
              fontSize="8.71px"
              fontFamily="var(--font-family-mono)"
              letterSpacing="0.005em"
              fill="#8497A2"
            >
              Vulnerability
            </text>
            <text
              x="226"
              y="221"
              fontSize="13.55px"
              fontFamily="var(--font-family-body)"
              fill="#092F45"
              letterSpacing="0.005em"
            >
              CVE Severity - Critical
            </text>
            <path
              d="M472.082 202.533L473.972 202.536L478.904 207.463L478.904 209.392L473.976 214.326L472.08 214.326L467.146 209.386L467.146 207.481L472.082 202.533Z"
              fill="#76CCAD"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M472.95 210.505L475.618 207.081L475.258 206.801L472.727 210.049L472.415 210.049L470.865 208.297L470.523 208.599L472.21 210.505L472.95 210.505Z"
              fill="white"
              stroke="white"
              strokeWidth="0.142606"
            />
            <rect
              x="203"
              y="67.2148"
              width="78.4855"
              height="22.6141"
              rx="3.87138"
              fill="#EAF1FC"
            />
            <text
              x="211"
              y="82"
              fontSize="9.68px"
              fontFamily="var(--font-family-mono)"
              letterSpacing="0.04em"
              fill="#092F45"
            >
              Conditions
            </text>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M349.145 288.3L353.097 292.748L354.766 292.748L358.703 288.299L357.978 287.658L354.413 291.686L354.413 251.486L353.445 251.486L353.445 291.682L349.868 287.657L349.145 288.3Z"
              fill="#2A6FE1"
            />
            <rect
              x="203"
              y="302.78"
              width="59.4855"
              height="22.6141"
              rx="3.87138"
              fill="#EAF1FC"
            />
            <text
              x="211"
              y="317"
              fontSize="9.68px"
              fontFamily="var(--font-family-mono)"
              letterSpacing="0.04em"
              fill="#092F45"
            >
              Actions
            </text>
            <rect
              x="203.484"
              y="101.572"
              width="300.032"
              height="63.8778"
              rx="7.25884"
              fill="#FAFCFD"
              stroke="#E6EAEC"
              strokeWidth="0.967846"
            />
            <text
              x="226"
              y="129"
              fontSize="8.71px"
              fontFamily="var(--font-family-mono)"
              letterSpacing="0.005em"
              fill="#8497A2"
            >
              Vulnerability
            </text>
            <text
              x="226"
              y="145"
              fontSize="13.55px"
              fontFamily="var(--font-family-body)"
              fill="#092F45"
              letterSpacing="0.005em"
            >
              {'CVSS Score > 6'}
            </text>
            <path
              d="M472.082 127.199L473.972 127.202L478.904 132.129L478.904 134.058L473.976 138.992L472.08 138.992L467.146 134.052L467.146 132.147L472.082 127.199Z"
              fill="#76CCAD"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M472.95 135.171L475.618 131.747L475.258 131.467L472.727 134.715L472.415 134.715L470.865 132.963L470.523 133.265L472.21 135.171L472.95 135.171Z"
              fill="white"
              stroke="white"
              strokeWidth="0.142606"
            />
            <rect
              x="203.484"
              y="337.139"
              width="300.032"
              height="63.8778"
              rx="7.25884"
              fill="#FAFCFD"
              stroke="#E6EAEC"
              strokeWidth="0.967846"
            />
            <text
              x="226"
              y="364"
              fontSize="8.71px"
              fontFamily="var(--font-family-mono)"
              letterSpacing="0.005em"
              fill="#8497A2"
            >
              Packages
            </text>
            <text
              x="226"
              y="381"
              fontSize="13.55px"
              fontFamily="var(--font-family-body)"
              fill="#092F45"
              letterSpacing="0.005em"
            >
              Quarantine
            </text>
            <path
              d="M472.082 362.766L473.972 362.769L478.904 367.697L478.904 369.625L473.976 374.56L472.08 374.559L467.146 369.62L467.146 367.715L472.082 362.766Z"
              fill="#76CCAD"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M472.95 370.739L475.618 367.315L475.258 367.035L472.727 370.283L472.415 370.283L470.865 368.531L470.523 368.833L472.21 370.739L472.95 370.739Z"
              fill="white"
              stroke="white"
              strokeWidth="0.142606"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter5_d_2375_90772"
            x="104"
            y="0"
            width="495"
            height="486"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="15" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0.627451 0 0 0 0 0.517647 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2375_90772"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2375_90772"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_2375_90772_0">
            <rect
              width="22"
              height="22"
              fill="white"
              transform="translate(16.5 72.6074)"
            />
          </clipPath>
          <clipPath id="clip1_2375_90772_1">
            <rect
              width="26"
              height="26"
              fill="white"
              transform="translate(14.5 139.607)"
            />
          </clipPath>
          <clipPath id="clip2_2375_90772_2">
            <path
              d="M134 32.9195C134 29.0979 137.098 26 140.919 26H569V445.081C569 448.902 565.902 452 562.081 452H134V32.9195Z"
              fill="white"
            />
          </clipPath>
          <pattern
            id="dot-pattern"
            viewBox="0 0 10 10"
            width={`${(10 / EXPLAINER_WIDTH) * 100}%`}
            height={`${(10 / EXPLAINER_HEIGHT) * 100}%`}
          >
            <circle
              cx="5"
              cy="5"
              r="1.155"
              fill="var(--brand-color-grey-5)"
              fillOpacity="0.1"
            />
          </pattern>
        </defs>
      </g>
    </Explainer>
  );
};

export default GetControl;
